<template>
  <div class="bindEmail">
    <p style="font-size: 20px;color: #000; text-align: center;">{{$t('emailToPwd')}}</p>
    <van-form>
        <van-field
         class="bind_form"
          v-model="email"
          :placeholder="$t('inputBindEmail')"
          :rules="[{ required: true, message: this.$t('noEmail') },{ pattern: /^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/, message: this.$t('emailPatternErr')}]"
        />
        <van-field
          class="bind_code"
          v-model="code"
          :placeholder="$t('inputCode')"
        >
        </van-field>
        <van-button
          class="bind_btn" 
          size="small"  
          type="danger"
          block
          round
          :disabled="disabled"
          @click="sendHandle"
        >
          {{$t('sendCode')}}
        </van-button>
        <van-button
          class="bind_btn"
          size="small"  
          native-type="submit"
          type="danger"
          block
          round
          @click="onSubmit"
          :disabled='isDisabled'
        >
          {{$t('bind')}}
        </van-button>
    </van-form>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import { Dialog } from 'vant';
import Qs from 'qs';
import { Toast } from 'vant';

export default {
  name: 'BindEmail',
  data($vm){
    return{
      email: '',
      code: '',
      isDisabled: false,
      disabled: false,
      accessToken: localStorage.getItem('accessToken'),
      appId: localStorage.getItem('appId'),
      language: localStorage.getItem('language'),
      sendCode: $vm.$t('sendCode')
    }
  },
  created(){
  },
  methods:{
      ...mapActions(['getEmailCode', 'setPayEmail']),
      onSubmit(){
        if(/^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(this.email)){
          if(this.code){
            if(!this.isDisabled){
              this.setPayEmail(Qs.stringify({
                appId: this.appId,
                language: this.language,
                accessToken: this.accessToken,
                email: this.email,
                verifyCode: this.code,
                uid: window.localStorage.getItem('uid')
              }))
              this.isDisabled = true
            }
          }
        }
      },
      sendHandle(){
        if(/^([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(this.email)){
          Dialog.confirm({
            title: this.$t('sureAgain'),
            message: this.$t('emailDialog'),
            cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('sure')
          })
          .then(() => {
            this.getEmailCode({
              emailType: 1,
              appId: this.appId,
              targetEmail: this.email,
              accessToken: this.accessToken,
              language: this.language,
              uid: window.localStorage.getItem('uid')
            })
          })
          .catch(() => {
            // on cancel
          });
        }
      }
  },
  computed:{
      ...mapGetters(['codeStatus', 'codeData', 'seStatus', 'setEmailData']),
  },
  mounted(){
    this.sendCode = this.$t('sendCode')
    this.$watch('codeStatus', val => {
      if(val === 'stated'){
        if(this.codeData == 'success'){
          Toast.success(this.$t('sended'))
          this.disabled = true
          let count = 30
          let interval = setInterval(() => {
            if(count === 0){
              this.disabled = false
              this.sendCode = this.$t('sendCode')
              clearInterval(interval)
            } else {
              count--
              this.sendCode = count + this.$t('retry')
            }
          }, 1000)
        }
      }
    })
    this.$watch('seStatus', val => {
      if(val === 'stated'){
        // console.log(this.checkState)
        if(this.setEmailData === 'success'){
          this.$router.push({
            path: '/bindsuccess',
            query: {
              email: this.email,
              from: this.$route.query.from || ''
            }
          });
        } else {
          this.isDisabled = false
        }
      }
    })
    this.$watch('code', val => {
      this.isDisabled = false
    })
  }
}
</script>
<style lang="scss" scoped>
.bindEmail{
    margin: 20px;
    .bind_form{
      margin-top: 20px;
      border-radius: 5px;
      box-shadow: 0px 0px 5px 2px #ebebeb;
    }
    .bind_code{
      margin-top: 20px;
      border-radius: 5px;
      box-shadow: 0px 0px 5px 2px #ebebeb;
    }
    .bind_btn{
        margin-top: 20px;
        width: 90%;
        left: 5%;
        padding: 15px;
    }
}
</style>